import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import { useAuthStore } from '@/stores/auth.js'
import axios from 'axios'

export const useFundraiserUpdatesStore = (id = 'default') => {
  return defineStore({
    id: `fundraiserUpdates_${id}`,
    state: () => ({
      items: [],
      api: '/api/v1/fundraiser-updates'
    }),
    getters: {
      ...getters,
      getItemsByUpdatable (state) {
        return (obj) => state.items.filter(item => item.updatable_type === obj.updatable_type && item.updatable_id === obj.id)
      }
    },
    actions: {
      ...actions
    }
  })()
}
